document.addEventListener('click', event => {
  const filterButton = event.target.closest('main.ms-blog-main [data-blog-filter]');
  if (!filterButton) return;

  const main = filterButton.closest('main.ms-blog-main');
  const list = main?.querySelector('.ms-blog-list');
  const emptyMessage = main?.querySelector('[data-blog-empty]');
  if (!list || !emptyMessage) return;

  const selectedCategory = filterButton.dataset.blogFilter;
  const buttons = main.querySelectorAll('[data-blog-filter]');
  const items = list.querySelectorAll('[data-blog-item]');
  let visibleItems = 0;

  buttons.forEach(button => {
    button.setAttribute('aria-pressed', String(button === filterButton));
  });

  items.forEach(item => {
    const visible = selectedCategory === 'all' || item.dataset.blogCategory === selectedCategory;
    item.hidden = !visible;
    if (visible) visibleItems += 1;
  });

  emptyMessage.hidden = visibleItems > 0;
});
